<template>
  <FormItem v-bind="itemProp">
    <Select
      :value="selectVal"
      filterable
      multiple
      allow-create
      placeholder="请输入，按回车添加"
      @input="inputHandler"
    >
      <Option
        v-for="item in tagList"
        :value="item"
        :key="item"
        >{{ item }}</Option
      >
    </Select>
  </FormItem>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    selectVal() {
      return this.value?.split(' ') || [];
    },
		tagList() {
      if (!this.value) return [''];
      return this.selectVal;
		},
    itemProp() {
      return {
        label: '自定义标签',
        ...this.formItemProps,
      }
    },
  },
  methods: {
    inputHandler(val) {
      this.$emit('input', val?.join(' ') || '')
    }
  }
}
</script>
